<template>
  <div class="formLayout">
    <slot />
  </div>
</template>

<style lang="scss">
.formLayout {
  .label__link {
    color: $text-400;
    text-decoration: underline;
  }
  
  .underline {
    text-decoration: underline;
  }

  .bs-input--disabled {
    .bs-input__input {
      background-color: $gray-300 !important;
    }
  }
  
  .bs-input__input {
    width: 100%;
    height: 4.8rem;
    background-color: $white !important;

    &::placeholder {
      color: $gray-500;
    }
  }
  
  .bs-input__label, .bs-select__label {
    @include body-3-medium;
    color: $text-300;
  }
  
  .wellbeingForm__consentAll {
    .bs-checkbox__label {
      color: $text-300;
      font-weight: 500;
    }
  }

  .textarea {
    max-height: 9.6rem;
    height: 9.6rem;
    margin-bottom: 3.2rem;

    @include atM {
      max-height: 10.2rem;
      height: 10.2rem;
    }
  }

  textarea {
    width: 100%;
    height: 100%;
    padding: 0.8rem 1.6rem;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;

    &::-webkit-input-placeholder {
      color: $text-200;
    }

    &:-ms-input-placeholder {
      color: $text-200;
    }

    &::placeholder {
      color: $text-200;
    }

    @include atM {
      padding: 1.2rem 1.6rem;
    }
  }
}
</style>

<style lang="scss" scoped>
.formLayout {
  display: grid;
  flex-wrap: wrap;
  gap: 1.6rem;
}
</style>

